import React from 'react';
import {Link} from 'react-router-dom';

import { Container, Row, Col } from 'reactstrap';
import EditUserForm from './EditUserForm';
import EditUserSubmitButton from './EditUserSubmitButton';

const AccountEdit = () => {
    return (
        <Container>
            <Row>
                <Col sm="12" md={{ size: 6, offset: 3 }}>
                    <div className="mt2 mb2">
                        <EditUserForm />
                    </div>
                    <div className="" style={{width: '100%'}}>
                        <div className="fr mb3">
                            <EditUserSubmitButton />
                            <Link to='/dashboard/'>Cancel</Link>
                        </div>
                    </div>
                </Col>
            </Row>
        </Container>
    );
}

export default AccountEdit;


// WEBPACK FOOTER //
// ./src/components/Account/Edit/AccountEdit.js